var _g, _g2, _g3, _g4, _path, _use, _use2, _path2, _use3, _use4, _use5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _circle2, _g5, _use6, _use7, _use8, _use9, _g6, _g7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCskh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_22134_55627)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_22134_55627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7952 11.8245C28.5762 11.8245 29.2892 11.6069 29.88 11.0969C29.88 11.0969 31.7339 8.75121 31.1771 7.77212C31.0888 7.61574 30.8375 7.47975 30.4165 7.41176C25.6425 6.64345 24.0195 12.8307 24.0195 12.8307C24.0195 12.8307 24.4202 13.3271 25.174 13.7282C25.174 13.7282 27.5983 15.1221 28.8275 14.8637C29.5948 14.7005 29.5812 14.1158 29.4658 13.6942C28.9633 13.7554 28.5761 13.4912 28.0533 13.2455C28.5354 13.4019 28.9836 13.6126 29.4862 13.6806C31.4623 12.6676 29.8732 11.1037 29.8732 11.1037C29.4077 11.6178 28.5761 12.0341 27.7885 11.8313L27.7952 11.8245Z",
    fill: "url(#paint0_linear_22134_55627)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_22134_55627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.03874 11.8303C3.25779 11.8303 2.54475 11.6127 1.95395 11.1028C1.95395 11.1028 0.100049 8.75707 0.656898 7.77798C0.745179 7.6216 0.996439 7.48561 1.41747 7.41762C6.19144 6.64931 7.81445 12.8366 7.81445 12.8366C7.81445 12.8366 7.41379 13.3329 6.66001 13.7341C6.66001 13.7341 4.23567 15.1279 3.00653 14.8696C2.23916 14.7064 2.25275 14.1216 2.36819 13.7001C2.87072 13.7613 3.25789 13.4971 3.78069 13.2513C3.29854 13.4077 2.85034 13.6185 2.34782 13.6865C0.371683 12.6734 1.96074 11.1096 1.96074 11.1096C2.42629 11.6237 3.25789 12.04 4.04553 11.8371L4.03874 11.8303Z",
    fill: "url(#paint1_linear_22134_55627)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_22134_55627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.093 14.911C28.093 16.0043 27.3828 16.9243 26.413 17.2088C26.237 17.2603 26.0521 17.2914 25.8628 17.2985C25.8352 17.2985 25.8068 17.3003 25.7792 17.3003C25.7561 17.3003 25.7321 17.3003 25.709 17.2977C25.6032 17.2959 25.4983 17.2852 25.3961 17.2674C25.4326 17.0603 25.437 16.8701 25.445 16.6408C25.5117 14.6301 25.3454 13.4123 25.125 12.6203C25.3321 12.5563 25.5517 12.5234 25.7792 12.5234C27.0566 12.5234 28.093 13.5919 28.093 14.911Z",
    fill: "url(#paint2_linear_22134_55627)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 14.911C2.8125 16.0043 3.52272 16.9243 4.4925 17.2088C4.69428 17.2692 4.90761 17.3003 5.12628 17.3003C5.14939 17.3003 5.17339 17.3003 5.19561 17.2985C5.30139 17.2968 5.40628 17.2861 5.5085 17.2683C5.47206 17.0612 5.46761 16.871 5.45961 16.6417C5.39294 14.6301 5.55917 13.4123 5.77961 12.6203C5.5725 12.5572 5.35294 12.5234 5.12539 12.5234C3.84894 12.5234 2.8125 13.5928 2.8125 14.911Z",
    fill: "url(#paint3_linear_22134_55627)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_iii_22134_55627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5273 14.6717C25.3918 11.3123 23.4464 8.82153 20.0436 7.66779C18.6269 7.18593 17.1221 6.96875 15.1767 6.96875C13.0483 6.96875 10.9674 7.64743 10.3776 7.85103C7.79506 8.76045 6.04623 10.8033 5.57175 13.4569C5.43618 14.2034 5.36162 14.9703 5.34128 15.7372C5.32772 16.4091 5.35484 17.081 5.42262 17.7597C5.44973 18.0379 5.4904 18.3094 5.53107 18.5877C6.03268 21.7299 8.23566 23.9899 11.5842 24.7908C12.6891 25.0487 13.8617 25.1776 15.17 25.1776C15.8139 25.1776 16.4714 25.1505 17.3187 25.0894C18.4439 25.0012 19.6369 24.7365 20.7689 24.3157C23.365 23.3655 25.1478 21.1191 25.4257 18.4587C25.446 18.2551 25.4663 18.0447 25.4799 17.8343C25.5273 17.1896 25.5545 16.5177 25.5545 15.8187C25.5545 15.4454 25.5409 15.0653 25.5273 14.6717Z",
    fill: "url(#paint4_linear_22134_55627)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_dif_22134_55627)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke0_22134_55627",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke0_22134_55627",
    fill: "url(#paint5_radial_22134_55627)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1413 15.786C21.0803 14.2406 20.2601 13.4339 18.7214 12.912C17.7521 12.5866 16.6811 12.4375 15.156 12.4375C13.8952 12.4375 12.4243 12.8442 11.7193 13.0882C10.7229 13.4407 10.0789 14.1592 9.89593 15.176C9.67224 16.43 9.67224 17.6975 9.86881 18.9515C10.0925 20.375 11.116 21.1003 12.4988 21.4256C14.0036 21.7849 15.5356 21.7375 17.0539 21.6222C17.8402 21.5612 18.6401 21.3646 19.3789 21.0935C20.3143 20.7478 20.9515 20.0429 21.0532 19.0803C21.1684 17.989 21.182 16.8773 21.1413 15.7725V15.786Z",
    fill: "url(#paint6_linear_22134_55627)",
    strokeWidth: 0.267542,
    stroke: "url(#paint7_linear_22134_55627)"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke1_22134_55627",
    fill: "#848484"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke1_22134_55627",
    fill: "url(#paint8_linear_22134_55627)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4424 19.5283C15.8108 19.5283 16.128 19.7447 16.2764 20.0566C16.129 20.3709 15.8115 20.5897 15.4414 20.5898C15.0727 20.5898 14.7556 20.3729 14.6074 20.0605C14.7549 19.7467 15.0726 19.5285 15.4424 19.5283Z",
    fill: "url(#paint9_linear_22134_55627)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke2_22134_55627",
    fill: "#474747"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke2_22134_55627",
    fill: "url(#paint10_radial_22134_55627)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke2_22134_55627",
    fill: "url(#paint11_radial_22134_55627)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.3125,
    y: 16.7363,
    width: 0.646633,
    height: 0.646633,
    fill: "#474747"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3125,
    y: 16.7363,
    width: 0.646633,
    height: 0.646633,
    fill: "url(#paint12_radial_22134_55627)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.959,
    y: 16.0918,
    width: 0.646633,
    height: 0.646633,
    fill: "#474747"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.959,
    y: 16.0918,
    width: 0.646633,
    height: 0.646633,
    fill: "url(#paint13_radial_22134_55627)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18.6035,
    y: 16.7363,
    width: 0.646633,
    height: 0.646633,
    fill: "#474747"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 18.6035,
    y: 16.7363,
    width: 0.646633,
    height: 0.646633,
    fill: "url(#paint14_radial_22134_55627)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5214,
    cy: 18.4953,
    r: 0.297268,
    transform: "rotate(-4.21204 11.5214 18.4953)",
    fill: "url(#paint15_linear_22134_55627)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.3906,
    cy: 18.4836,
    r: 0.297268,
    transform: "rotate(-4.21204 19.3906 18.4836)",
    fill: "url(#paint16_linear_22134_55627)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_iii_22134_55627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3368 23.6834C18.208 24.1652 18.0454 24.6471 17.8488 25.1222C17.8013 25.2308 17.6929 25.3122 17.5573 25.3393C16.161 25.604 14.7307 25.604 13.3344 25.3393C13.1988 25.3122 13.0904 25.2308 13.0429 25.1222C12.8463 24.6471 12.6837 24.1652 12.5549 23.6834C12.4939 23.4458 12.7243 23.2422 12.9548 23.3101C14.5816 23.7512 16.2965 23.7512 17.9234 23.3101C18.1606 23.2422 18.3843 23.4458 18.3233 23.6834H18.3368Z",
    fill: "url(#paint17_linear_22134_55627)"
  }))), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke3_22134_55627",
    fill: "#595959"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke3_22134_55627",
    fill: "url(#paint18_linear_22134_55627)"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke4_22134_55627",
    fill: "#595959"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke4_22134_55627",
    fill: "url(#paint19_linear_22134_55627)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_ii_22134_55627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0123 17.2666C25.3579 19.2218 23.822 20.051 22.4567 20.3892C21.7326 20.5679 21.0462 20.6122 20.541 20.6122C20.2885 20.6122 20.081 20.6011 19.935 20.5891C19.8621 20.5836 19.8055 20.5781 19.7661 20.5744C19.7464 20.5716 19.7309 20.5698 19.7202 20.5688C19.7153 20.5688 19.7112 20.5688 19.7079 20.567H19.7038C19.7038 20.567 19.7038 20.567 19.7046 20.555L19.703 20.5661C19.5906 20.5513 19.5111 20.4362 19.525 20.3099C19.5381 20.1837 19.6406 20.0934 19.753 20.1091H19.7555C19.7555 20.1091 19.7604 20.1091 19.7653 20.1109C19.7743 20.1109 19.7874 20.1137 19.8055 20.1155C19.8416 20.1192 19.8949 20.1247 19.9629 20.1303C20.1007 20.1404 20.2991 20.1515 20.541 20.1515C21.0265 20.1515 21.6817 20.1091 22.3689 19.9386C23.635 19.6254 24.9142 18.891 25.5234 17.2344C25.6177 17.2528 25.7729 17.2639 25.8705 17.2657C25.8918 17.2685 25.9139 17.2685 25.9352 17.2685C25.9607 17.2685 25.9869 17.2675 26.0123 17.2666Z",
    fill: "url(#paint20_linear_22134_55627)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_ii_22134_55627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9954 19.2031H18.204C17.608 19.2031 17.125 19.6869 17.125 20.2838C17.125 20.8807 17.608 21.3645 18.204 21.3645H18.9954C19.5914 21.3645 20.0744 20.8807 20.0744 20.2838C20.0744 19.6869 19.5914 19.2031 18.9954 19.2031Z",
    fill: "url(#paint21_linear_22134_55627)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_22134_55627",
    x: 0.552734,
    y: 7.3457,
    width: 30.7285,
    height: 8.15488,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.599213
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.299607
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_55627"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_22134_55627",
    x: 23.2923,
    y: 5.89116,
    width: 7.98899,
    height: 9.73162,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.727273,
    dy: 0.727273
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.363636
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.900785 0 0 0 0 0.900785 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_55627"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.45455
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.727273
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.483398 0 0 0 0 0.483398 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_22134_55627",
    result: "effect2_innerShadow_22134_55627"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_22134_55627",
    x: -0.174538,
    y: 5.89702,
    width: 7.98899,
    height: 9.73162,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.727273,
    dy: 0.727273
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.363636
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.900785 0 0 0 0 0.900785 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_55627"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.45455
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.727273
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.483398 0 0 0 0 0.483398 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_22134_55627",
    result: "effect2_innerShadow_22134_55627"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_22134_55627",
    x: 2.8125,
    y: 12.1679,
    width: 25.2803,
    height: 5.6329,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.346229 0 0 0 0 0.346229 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_55627"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.355556
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.150222 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_22134_55627",
    result: "effect2_innerShadow_22134_55627"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_iii_22134_55627",
    x: 5.33789,
    y: 6.06321,
    width: 20.2168,
    height: 20.2465,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.679156
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.905541
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.158597 0 0 0 0 0.158597 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_55627"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.905541
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.35831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.775729 0 0 0 0 0.439322 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_22134_55627",
    result: "effect2_innerShadow_22134_55627"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.13193
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.35831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_22134_55627",
    result: "effect3_innerShadow_22134_55627"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dif_22134_55627",
    x: 7.12671,
    y: 8.52697,
    width: 16.039,
    height: 14.8174,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.399476,
    dy: -1.19843
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.599213
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22134_55627"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22134_55627",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.399476,
    dy: 0.399476
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.399476
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.507625 0 0 0 0 0.507625 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_22134_55627"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.499345,
    result: "effect3_foregroundBlur_22134_55627"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_iii_22134_55627",
    x: 12.5449,
    y: 22.6177,
    width: 5.79199,
    height: 3.59952,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.679156
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.905541
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.158597 0 0 0 0 0.158597 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_55627"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.679156
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.679156
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.855364 0 0 0 0 0.638409 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_22134_55627",
    result: "effect2_innerShadow_22134_55627"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.452771
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.679156
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_22134_55627",
    result: "effect3_innerShadow_22134_55627"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_ii_22134_55627",
    x: 19.5234,
    y: 16.8344,
    width: 6.48926,
    height: 3.77793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.346229 0 0 0 0 0.346229 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_55627"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.150222 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_22134_55627",
    result: "effect2_innerShadow_22134_55627"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_ii_22134_55627",
    x: 17.125,
    y: 18.8031,
    width: 2.94922,
    height: 2.56113,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.346229 0 0 0 0 0.346229 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_55627"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.150222 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_22134_55627",
    result: "effect2_innerShadow_22134_55627"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22134_55627",
    x1: 27.9442,
    y1: 8.10281,
    x2: 27.9403,
    y2: 15.3755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFCFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC7B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22134_55627",
    x1: 3.88974,
    y1: 8.10866,
    x2: 3.89364,
    y2: 15.3814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFCFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC7B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_22134_55627",
    x1: 25.125,
    y1: 17.279,
    x2: 25.125,
    y2: 11.9901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#170000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#370000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_22134_55627",
    x1: 2.8125,
    y1: 17.279,
    x2: 2.8125,
    y2: 11.9901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#170000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#370000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_22134_55627",
    x1: 15.4443,
    y1: 8.94099,
    x2: 15.4443,
    y2: 26.1864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EE0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8D58"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_22134_55627",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-9.6608 2.7363 -3.22027 -8.2089 19.7516 14.5748)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD490"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_22134_55627",
    x1: 15.4555,
    y1: 11.9975,
    x2: 15.6962,
    y2: 22.5485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366298,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_22134_55627",
    x1: 11.5015,
    y1: 11.8555,
    x2: 18.0384,
    y2: 21.9202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322115,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595864,
    stopColor: "#FFE3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947115,
    stopColor: "#FFF5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_22134_55627",
    x1: 15.4415,
    y1: 18.8838,
    x2: 15.4415,
    y2: 20.1772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE4D50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_22134_55627",
    x1: 15.4422,
    y1: 18.6976,
    x2: 15.4422,
    y2: 20.2668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_22134_55627",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.12532 0.764831 -0.375108 -2.29449 13.1126 16.1631)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#502828"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_22134_55627",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.12532 0.764831 -0.375108 -2.29449 13.1126 16.1631)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#502828"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_22134_55627",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8429 16.943) rotate(161.565) scale(0.489864)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#502828"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_22134_55627",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.4894 16.2985) rotate(161.565) scale(0.489864)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#502828"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_22134_55627",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.134 16.943) rotate(161.565) scale(0.489864)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#502828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_22134_55627",
    x1: 11.5214,
    y1: 18.1981,
    x2: 11.5214,
    y2: 18.7926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_22134_55627",
    x1: 19.3906,
    y1: 18.1863,
    x2: 19.3906,
    y2: 18.7809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_22134_55627",
    x1: 15.4461,
    y1: 23.2782,
    x2: 15.4461,
    y2: 29.3037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EE0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8D58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_22134_55627",
    x1: 14.0282,
    y1: 7.84596,
    x2: 13.6978,
    y2: 11.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFC9C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_22134_55627",
    x1: 13.9453,
    y1: 8.82587,
    x2: 13.7429,
    y2: 11.3006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFC9C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_22134_55627",
    x1: 19.5234,
    y1: 20.5971,
    x2: 19.5234,
    y2: 16.8573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#170000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#370000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_22134_55627",
    x1: 17.125,
    y1: 21.3548,
    x2: 17.125,
    y2: 18.9618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#170000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#370000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "stroke0_22134_55627",
    d: "M15.1695 22.3459C14.1324 22.3459 13.2173 22.2509 12.37 22.0473C9.8417 21.4433 9.07574 19.8484 8.87916 18.6132C8.66226 17.2627 8.67581 15.9121 8.90628 14.6158C9.16386 13.177 10.0857 12.1115 11.5024 11.6093C11.8278 11.4939 13.5427 10.9238 15.1763 10.9238C16.7624 10.9238 17.8944 11.0799 18.9586 11.4396C21.0261 12.1387 22.0632 13.4281 22.1445 15.3692C22.1919 16.5636 22.1648 17.6427 22.0564 18.6675C21.914 20.052 20.9922 21.1786 19.6026 21.6876C18.7553 21.9998 17.8741 22.1966 17.0607 22.2577C16.3083 22.312 15.7253 22.3391 15.1695 22.3391V22.3459ZM13.9291 17.9888C13.9291 17.9888 13.963 17.9956 13.9833 18.0024Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "stroke1_22134_55627",
    d: "M14.5176 18.4932C14.5176 18.3772 14.6116 18.2832 14.7276 18.2832H16.1554C16.2714 18.2832 16.3654 18.3772 16.3654 18.4932V19.6691C16.3654 20.1794 15.9518 20.593 15.4415 20.593V20.593C14.9312 20.593 14.5176 20.1794 14.5176 19.6691V18.4932Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "stroke2_22134_55627",
    d: "M13.3939 15.7797V17.698C13.3939 18.0505 13.1092 18.3352 12.7568 18.3352H12.4721C12.1196 18.3352 11.8281 18.0505 11.8281 17.698V16.5999H12.3772V16.0509H12.9262V15.5018H12.3772V16.0509H11.8281V15.7797C11.8281 15.4273 12.1196 15.1426 12.4721 15.1426H12.7568C13.1092 15.1426 13.3939 15.4273 13.3939 15.7797Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "stroke3_22134_55627",
    d: "M16.7232 10.452C16.4114 10.452 16.391 10.4384 16.3368 10.1466C16.147 9.0743 15.2726 8.49064 14.3101 8.3074C14.2423 8.29383 14.1677 8.28704 14.0999 8.28025C13.8356 8.23953 13.8559 8.1038 13.8627 8.05629C13.8627 7.98163 13.8627 7.91377 13.8898 7.83911C13.9237 7.71016 14.0525 7.71695 14.1135 7.72374C15.4217 7.83233 16.3842 8.38205 16.9062 9.57652C16.9807 9.74619 17.0146 9.92943 17.0485 10.1059C17.1095 10.4113 17.0621 10.452 16.7367 10.452H16.7232Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "stroke4_22134_55627",
    d: "M15.4827 10.4452C15.1913 10.4452 15.198 10.4452 15.1303 10.1805C15.0082 9.73936 14.6897 9.48146 14.2423 9.34573C14.2016 9.33215 14.1542 9.32537 14.1135 9.31858C13.8559 9.26428 13.8152 9.21678 13.8491 8.97924C13.8695 8.83672 13.944 8.75528 14.1067 8.74849C14.7371 8.73492 15.198 9.03353 15.5437 9.49503C15.6996 9.69864 15.7878 9.94975 15.8555 10.2144C15.8894 10.357 15.8216 10.4384 15.6522 10.4452C15.598 10.4452 15.5437 10.4452 15.4895 10.4452H15.4827Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCskh);
export default __webpack_public_path__ + "static/media/ic_cskh.e1020aa3a143162480d7fa496945a422.svg";
export { ForwardRef as ReactComponent };